export default __webpack_public_path__ + "static/media/chat.4462193f.svg";